import type { Field } from '@/modules/Project/Fields/types'

export const buildTextField = (overrides: Partial<Field<'text'>> = {}): Field<'text'> => ({
  entityId: 'entity-1',
  type: 'text',
  propertyId: 'prop-text-1',
  manualValue: null,
  manualValueUpdatedBy: null,
  toolValue: null,
  toolValueUpdatedBy: null,
  status: 'idle',
  errorMessage: null,
  propertyHash: null,
  groundTruth: false,
  hasGrounding: false,
  updatedAt: '2023-09-01T12:00:00Z',
  createdAt: '2023-09-01T12:00:00Z',
  staleness: {
    status: 'up_to_date',
  },
  ...overrides,
})

export const buildFileField = (overrides: Partial<Field<'file'>> = {}): Field<'file'> => ({
  entityId: 'entity-1',
  type: 'file',
  propertyId: 'prop-file-1',
  manualFilename: null,
  manualValue: null,
  manualValueUpdatedBy: null,
  toolFilename: null,
  toolValue: null,
  toolValueUpdatedBy: null,
  status: 'idle',
  errorMessage: null,
  propertyHash: null,
  groundTruth: false,
  updatedAt: '2023-09-01T12:00:00Z',
  createdAt: '2023-09-01T12:00:00Z',
  manualValuePDF: null,
  toolValuePDF: null,
  staleness: {
    status: 'up_to_date',
  },
  ...overrides,
})

export const buildDataField = (
  overrides: Partial<Omit<Field<'data'>, 'type'>> = {},
): Field<'data'> => ({
  ...buildFileField(overrides),
  type: 'data',
})

export const buildSingleSelectField = (
  overrides: Partial<Field<'single_select'>> = {},
): Field<'single_select'> => ({
  entityId: 'entity-1',
  type: 'single_select',
  propertyId: 'prop-single-select-1',
  manualValue: null,
  manualValueUpdatedBy: null,
  toolValue: null,
  toolValueUpdatedBy: null,
  metadata: {},
  status: 'idle',
  errorMessage: null,
  propertyHash: null,
  groundTruth: false,
  updatedAt: '2023-09-01T12:00:00Z',
  createdAt: '2023-09-01T12:00:00Z',
  staleness: {
    status: 'up_to_date',
  },
  ...overrides,
})

export const buildMultiSelectField = (
  overrides: Partial<Field<'multi_select'>> = {},
): Field<'multi_select'> => ({
  entityId: 'entity-1',
  type: 'multi_select',
  propertyId: 'prop-multi-select-1',
  manualValue: null,
  manualValueUpdatedBy: null,
  toolValue: null,
  toolValueUpdatedBy: null,
  metadata: {},
  status: 'idle',
  errorMessage: null,
  propertyHash: null,
  groundTruth: false,
  updatedAt: '2023-09-01T12:00:00Z',
  createdAt: '2023-09-01T12:00:00Z',
  staleness: {
    status: 'up_to_date',
  },
  ...overrides,
})

export const buildJsonField = (overrides: Partial<Field<'json'>> = {}): Field<'json'> => ({
  entityId: 'entity-1',
  type: 'json',
  propertyId: 'prop-json-1',
  manualValue: null,
  manualValueUpdatedBy: null,
  toolValue: null,
  toolValueUpdatedBy: null,
  status: 'idle',
  errorMessage: null,
  propertyHash: null,
  groundTruth: false,
  updatedAt: '2023-09-01T12:00:00Z',
  createdAt: '2023-09-01T12:00:00Z',
  hasGrounding: false,
  staleness: {
    status: 'up_to_date',
  },
  ...overrides,
})

export const buildUrlField = (overrides: Partial<Field<'url'>> = {}): Field<'url'> => ({
  entityId: 'entity-1',
  type: 'url',
  propertyId: 'prop-url-1',
  manualValue: null,
  manualValueUpdatedBy: null,
  toolValue: null,
  toolValueUpdatedBy: null,
  status: 'idle',
  errorMessage: null,
  propertyHash: null,
  groundTruth: false,
  updatedAt: '2023-09-01T12:00:00Z',
  createdAt: '2023-09-01T12:00:00Z',
  metadata: {},
  staleness: {
    status: 'up_to_date',
  },
  ...overrides,
})

export const buildFileCollectionField = (
  overrides: Partial<Field<'file_collection'>> = {},
): Field<'file_collection'> => ({
  entityId: 'entity-1',
  type: 'file_collection',
  propertyId: 'prop-file-collection-1',
  manualFilename: null,
  manualName: null,
  manualValue: null,
  manualValueUpdatedBy: null,
  toolFilename: null,
  toolValue: null,
  toolValueUpdatedBy: null,
  status: 'idle',
  errorMessage: null,
  propertyHash: null,
  groundTruth: false,
  updatedAt: '2023-09-01T12:00:00Z',
  createdAt: '2023-09-01T12:00:00Z',
  staleness: {
    status: 'up_to_date',
  },
  ...overrides,
})

export const buildUserSelectField = (
  overrides: Partial<Field<'user_select'>> = {},
): Field<'user_select'> => ({
  entityId: 'entity-1',
  type: 'user_select',
  propertyId: 'prop-user-select-1',
  manualValue: null,
  manualValueUpdatedBy: null,
  toolValue: null,
  toolValueUpdatedBy: null,
  status: 'idle',
  errorMessage: null,
  propertyHash: null,
  groundTruth: false,
  updatedAt: '2023-09-01T12:00:00Z',
  createdAt: '2023-09-01T12:00:00Z',
  staleness: {
    status: 'up_to_date',
  },
  ...overrides,
})

export const buildCollectionField = (
  overrides: Partial<Field<'collection'>> = {},
): Field<'collection'> => ({
  entityId: 'entity-1',
  type: 'collection',
  propertyId: 'prop-collection-1',
  manualValue: null,
  manualValueUpdatedBy: null,
  manualName: null,
  toolValue: null,
  toolValueUpdatedBy: null,
  status: 'idle',
  errorMessage: null,
  propertyHash: null,
  groundTruth: false,
  updatedAt: '2023-09-01T12:00:00Z',
  createdAt: '2023-09-01T12:00:00Z',
  staleness: {
    status: 'up_to_date',
  },
  ...overrides,
})

export const buildNumberField = (overrides: Partial<Field<'number'>> = {}): Field<'number'> => ({
  entityId: 'entity-1',
  type: 'number',
  propertyId: 'prop-number-1',
  manualValue: null,
  manualValueUnit: null,
  manualValueRaw: null,
  manualValueUpdatedBy: null,
  toolValue: null,
  toolValueUnit: null,
  toolValueRaw: null,
  toolValueUpdatedBy: null,
  status: 'idle',
  errorMessage: null,
  propertyHash: null,
  groundTruth: false,
  updatedAt: '2023-09-01T12:00:00Z',
  createdAt: '2023-09-01T12:00:00Z',
  metadata: null,
  hasGrounding: false,
  staleness: {
    status: 'up_to_date',
  },
  ...overrides,
})

export const buildReferenceField = (
  overrides: Partial<Field<'reference'>> = {},
): Field<'reference'> => ({
  entityId: 'entity-1',
  type: 'reference',
  propertyId: 'prop-number-1',
  manualValue: null,
  manualValueUpdatedBy: null,
  toolValue: null,
  toolValueUpdatedBy: null,
  status: 'idle',
  errorMessage: null,
  propertyHash: null,
  groundTruth: false,
  updatedAt: '2023-09-01T12:00:00Z',
  createdAt: '2023-09-01T12:00:00Z',
  staleness: {
    status: 'up_to_date',
  },
  toolEntityIds: null,
  manualEntityIds: null,
  metadata: null,
  subprojectPreview: {
    entity_previews: [],
    total_entity_count: 0,
  },
  ...overrides,
})
